import { SET_USER_INFO, RESET_USER_INFO, SET_WODS } from "../types/types";

export const setUserInfo = (value) => {
  return {
    type: SET_USER_INFO,
    payload: { data: value },
  };
};

export const resetUserInfo = () => {
  return {
    type: RESET_USER_INFO,
    payload: { data: {} },
  };
};

export const setWods = (value) => {
  return {
    type: SET_WODS,
    payload: { data: value },
  };
};
export const setTempMobileToken = (value) => {
  return {
    type: "SET_TEMP_MOBILE_TOKEN",
    payload: { data: value },
  };
};
